import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  exportCustomers,
} from "../../features/customers/api/customers.api";
import type {
  GetCustomersParams,
  CreateCustomerDto,
  UpdateCustomerDto,
  ExportCustomersCriteria,
} from "../../features/customers/types/customers.types";

export const getCrmCustomer = createAsyncThunk(
  "customers/getCrmCustomer",
  async (params: GetCustomersParams, { rejectWithValue }) => {
    try {
      return await getCustomers(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCrmCustomer = createAsyncThunk(
  "customers/addCrmCustomer",
  async (customer: CreateCustomerDto, { rejectWithValue }) => {
    try {
      const response = await createCustomer(customer);
      toast.success("Cliente creado", { autoClose: 3000 });
      return response;
    } catch (error: any) {
      const raw = error?.raw;
      if (raw?.error && Array.isArray(raw.error)) {
        raw.error.forEach((err: { message: string }) =>
          toast.error(err.message, { autoClose: 3000 })
        );
      } else {
        toast.error(error?.message ?? "Error creando cliente", { autoClose: 3000 });
      }
      return rejectWithValue(error);
    }
  }
);

export const updateCrmCustomer = createAsyncThunk(
  "customers/updateCrmCustomer",
  async (customer: UpdateCustomerDto, { rejectWithValue }) => {
    try {
      const data = await updateCustomer(customer.id, customer);
      toast.success("El cliente se actualizó correctamente", { autoClose: 3000 });
      return data;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al actualizar el cliente", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const deleteCrmCustomer = createAsyncThunk(
  "customers/deleteCrmCustomer",
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteCustomer(id);
      toast.success("El cliente ha sido eliminado con éxito", { autoClose: 2000 });
      return { id };
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al eliminar el cliente", { autoClose: 2000 });
      return rejectWithValue(error);
    }
  }
);

export const exportCrmCustomers = createAsyncThunk(
  "customers/exportCrmCustomers",
  async (criteria: ExportCustomersCriteria | undefined, { rejectWithValue }) => {
    try {
      const blob = await exportCustomers(criteria);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "clientes.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
